module.exports = __webpack_public_path__ + "static/suffolk-therapy-flower-f1169ad481f2982b12ea1bfcf037c6c8.jpg";